import { TableCell, TableHead, TableRow } from "@material-ui/core";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import arrayMove from "array-move";
import { useEffect, useState } from "react";
import { Datagrid, Filter, List, RecordContextProvider, ReferenceInput, SaveButton, SelectInput, Toolbar, useDataProvider } from "react-admin";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";

const DatagridHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell style={{ width: "50px" }}></TableCell> {/* Drag */}
      <TableCell style={{}}>Name in TC</TableCell>
      <TableCell style={{}}>Name in EN</TableCell>
    </TableRow>
  </TableHead>
);

const DragHandle = SortableHandle(() => (
  <TableCell>
    <ListItemIcon>
      <DragHandleIcon />
    </ListItemIcon>
  </TableCell>
));

const MyDatagridRow = ({ item }) => {
  return (
    <RecordContextProvider value={item}>
      <TableRow>
        <DragHandle />
        <TableCell style={{ overflowWrap: "anywhere" }}>{item.name_tc}</TableCell>
        <TableCell style={{ overflowWrap: "break-word" }}>{item.name_en}</TableCell>
      </TableRow>
    </RecordContextProvider>
  );
};

const SortableItem2 = SortableElement(({ allItems, setAllItems, pos, item, ...props }) => {
  return <MyDatagridRow allItems={allItems} setAllItems={setAllItems} item={item} pos={pos} {...props} />;
});

const MyDatagridBody = ({ allItems, setAllItems, data, ...props }) => {
  useEffect(() => {
    setAllItems(props.ids.map((id) => data[id])); //Preserve the order of items in List according to ids order, because dataProvider returns data in random order
  }, [data]);

  return allItems.map((item, index) => {
    return (
      <SortableItem2 //
        key={item.id}
        item={item}
        allItems={allItems}
        setAllItems={setAllItems}
        index={index}
        pos={index}
        {...props}
      />
    );
  });
};

const PlatformInput = () => {
  return (
    <ReferenceInput label="Platform" source="platform" reference="channel-categories-order-platforms">
      <SelectInput optionText="title" optionValue="id" />
    </ReferenceInput>
  );
};

const ListFilter = ({ setPlatform, ...props }) => {
  useEffect(() => {
    setPlatform(props.filterValues.platform);
  }, [props.filterValues]);

  return (
    <Filter {...props}>
      <PlatformInput label="Platform" source="platform" alwaysOn />
    </Filter>
  );
};

const DataGridEmptyView = () => {
  return (
    <div style={{ margin: "16px" }}>
      <p className="MuiTypography-root MuiTypography-body2">No results found</p>
    </div>
  );
};

const SortableListContainer = SortableContainer(({ setPlatform, allItems, setAllItems, ...props }) => {
  return (
    <List //
      empty={false}
      exporter={false}
      pagination={false}
      filters={<ListFilter setPlatform={setPlatform} />}
      filterDefaultValues={{ platform: "ios" }}
      {...props}
    >
      <Datagrid //
        header={<DatagridHeader />}
        body={
          <MyDatagridBody //
            allItems={allItems}
            setAllItems={setAllItems}
            {...props}
          />
        }
        empty={<DataGridEmptyView />}
      />
    </List>
  );
});

const onSave = async (dataProvider, platform, allItems) => {
  if (!allItems) {
    return;
  }

  const ids = allItems.map((i) => i.id);

  await dataProvider.updateChannelCategoriesOrder(platform, ids);

  window.location.reload(true);
};

export const ChannelCategoryOrderingList = (props) => {
  const dataProvider = useDataProvider();
  const [allItems, setAllItems] = useState([]);
  const [platform, setPlatform] = useState("ios"); //Because save button is outside of List, need to store platform in parent component. Otherwise, can directly get platform from filterValues in ListFilter component

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setAllItems((allItems) => arrayMove(allItems, oldIndex, newIndex));
  };

  return (
    <>
      <SortableListContainer //
        {...props}
        setPlatform={setPlatform}
        allItems={allItems}
        setAllItems={setAllItems}
        onSortEnd={onSortEnd}
        useDragHandle={true}
        lockAxis="y"
      />

      <Toolbar>
        <SaveButton
          label="Save"
          handleSubmitWithRedirect={async () => {
            await onSave(dataProvider, platform, allItems);
          }}
        />
      </Toolbar>
    </>
  );
};
